import React, { useState } from "react"
import PropTypes from "prop-types"

/**
 * GDPR-safe YouTube embed (click-to-load facade).
 *
 * Ništa se ne učitava s YouTubea dok posjetitelj ne klikne na video.
 * Reprodukcija koristi domenu youtube-nocookie.com pa se kolačići ne
 * postavljaju prije klika (privola).
 *
 * Props:
 *  - id     (obavezno) ID YouTube videa, npr. "dQw4w9WgXcQ"
 *  - title  naslov za pristupačnost / <iframe title>
 *  - poster lokalna slika za pregled (npr. iz src/images-objave). Ako se ne
 *           navede, koristi se YouTube naslovnica (i.ytimg.com).
 */
const YouTube = ({ id, title = "YouTube video", poster }) => {
  const [activated, setActivated] = useState(false)
  const thumb = poster || `https://i.ytimg.com/vi/${id}/hqdefault.jpg`
  const src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`

  return (
    <div
      className="youtube-embed"
      style={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%", // 16:9
        overflow: "hidden",
        borderRadius: "4px",
        backgroundColor: "#000",
      }}
    >
      {activated ? (
        <iframe
          src={src}
          title={title}
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: 0,
          }}
        />
      ) : (
        <button
          type="button"
          onClick={() => setActivated(true)}
          aria-label={`Pokreni video: ${title}`}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            padding: 0,
            border: 0,
            cursor: "pointer",
            backgroundColor: "#000",
            backgroundImage: `url(${thumb})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <span
            aria-hidden="true"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "68px",
              height: "48px",
              borderRadius: "10px",
              backgroundColor: "rgba(0, 0, 0, 0.75)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span
              style={{
                display: "block",
                width: 0,
                height: 0,
                marginLeft: "4px",
                borderStyle: "solid",
                borderWidth: "10px 0 10px 18px",
                borderColor: "transparent transparent transparent #fff",
              }}
            />
          </span>
        </button>
      )}
    </div>
  )
}

YouTube.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  poster: PropTypes.string,
}

export default YouTube
